import { render, staticRenderFns } from "./ShopgenieLogoSvg.vue?vue&type=template&id=15b36f6a"
import script from "./ShopgenieLogoSvg.vue?vue&type=script&lang=js"
export * from "./ShopgenieLogoSvg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports